import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _428e5c04 = () => interopDefault(import('../../../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _e40c14a8 = () => interopDefault(import('../../../pages/activities.vue' /* webpackChunkName: "pages/activities" */))
const _76ce0704 = () => interopDefault(import('../../../pages/children.vue' /* webpackChunkName: "pages/children" */))
const _106f62ce = () => interopDefault(import('../../../pages/error.vue' /* webpackChunkName: "pages/error" */))
const _0662f39a = () => interopDefault(import('../../../pages/expenses.vue' /* webpackChunkName: "pages/expenses" */))
const _71acdc9d = () => interopDefault(import('../../../pages/forgotPassword.vue' /* webpackChunkName: "pages/forgotPassword" */))
const _0b58eede = () => interopDefault(import('../../../pages/home.vue' /* webpackChunkName: "pages/home" */))
const _658208e8 = () => interopDefault(import('../../../pages/income.vue' /* webpackChunkName: "pages/income" */))
const _7da9d37a = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _5429db22 = () => interopDefault(import('../../../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _c51cfee0 = () => interopDefault(import('../../../pages/reports.vue' /* webpackChunkName: "pages/reports" */))
const _1577b8ea = () => interopDefault(import('../../../pages/child/_childId.vue' /* webpackChunkName: "pages/child/_childId" */))
const _97fb9f3a = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _428e5c04,
    name: "account"
  }, {
    path: "/activities",
    component: _e40c14a8,
    name: "activities"
  }, {
    path: "/children",
    component: _76ce0704,
    name: "children"
  }, {
    path: "/error",
    component: _106f62ce,
    name: "error"
  }, {
    path: "/expenses",
    component: _0662f39a,
    name: "expenses"
  }, {
    path: "/forgotPassword",
    component: _71acdc9d,
    name: "forgotPassword"
  }, {
    path: "/home",
    component: _0b58eede,
    name: "home"
  }, {
    path: "/income",
    component: _658208e8,
    name: "income"
  }, {
    path: "/login",
    component: _7da9d37a,
    name: "login"
  }, {
    path: "/register",
    component: _5429db22,
    name: "register"
  }, {
    path: "/reports",
    component: _c51cfee0,
    name: "reports"
  }, {
    path: "/child/:childId?",
    component: _1577b8ea,
    name: "child-childId"
  }, {
    path: "/",
    component: _97fb9f3a,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
